var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.displaySrc)?_c('img',{class:_vm.imgClasses,attrs:{"src":_vm.displaySrc,"alt":_vm.alt,"loading":_vm.eager ? 'eager' : 'lazy',"decoding":"async"},on:{"load":_vm.onLoad,"error":_vm.onError}}):_c('div',{ref:"placeholder",class:_vm.placeholderClass})
}
var staticRenderFns = []

export { render, staticRenderFns }